import { render, staticRenderFns } from "./DSlider.vue?vue&type=template&id=663afc32&"
import script from "./DSlider.vue?vue&type=script&lang=js&"
export * from "./DSlider.vue?vue&type=script&lang=js&"
import style0 from "./DSlider.vue?vue&type=style&index=0&id=663afc32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports